module.exports = __webpack_public_path__ + "b461b38bd51b0284caec4e7b016384d6.pdf";